import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ServerService} from '../service/server.service';
import {
  AlertController,
  IonRouterOutlet,
  LoadingController,
  ModalController,
  NavController,
  Platform,
  ToastController
} from '@ionic/angular';
import {Camera} from '@awesome-cordova-plugins/camera/ngx';
import {FileTransfer} from '@awesome-cordova-plugins/file-transfer/ngx';
import {File} from '@awesome-cordova-plugins/file/ngx';
import {FilePath} from '@awesome-cordova-plugins/file-path/ngx';
import {TermsPage} from '../terms/terms.page';
import {AuthService} from "../service/auth.service";
import {AdminService} from "../service/admin.service";
import {Constant} from "../shared/model/Constant";

declare var cordova: any;

@Component({
  selector: 'app-signup',
  templateUrl: './signup.page.html',
  styleUrls: ['./signup.page.scss'],
})

export class SignupPage implements OnInit {

  hasTerm = false;
  user_id: any;
  res: any;
  show_form = false;
  lastImage: any;
  showImage: any;
  text: any;
  document: any;
  phone: any;
  documents: any;
  loading: any;
  firstName: any;
  secondName: any;
  firstLastName: any;
  secondSurName: any;

  constructor(
    private routerOutlet: IonRouterOutlet,
    public modalController: ModalController,
    private file: File,
    public alertController: AlertController,
    public server: ServerService,
    public toastController: ToastController,
    public loadingController: LoadingController,
    private authService: AuthService,
    private adminService: AdminService) {

  }

  async ngOnInit() {

    this.loading = await this.loadingController.create({
      message: '',
      spinner: 'bubbles',
      duration: 30000
    });
    this.getToken();
    this.getTypeIdentificationId();
  }

  getToken() {
    let data = {
      document: 9999999,                
      password: 'X%fq8$*Q_M3A9fai4AcEdkL2K5Pa$3'          
    };
    this.authService.login(data).subscribe((res: any) => {
      localStorage.setItem(Constant.token, res.token);
    }, error => {
      console.log("No se pudo obtener el token para el registro del cliente");
    });
  }

  term() {
    this.hasTerm = this.hasTerm == true ? false : true;

    if (this.hasTerm == true) {
      this.terms();
    }
  }

  showForm() {
    this.show_form = true;
  }

  async signup(data) {
    const loading = await this.loadingController.create({
      message: '',
      spinner: 'bubbles',
      duration: 3000
    });
    await loading.present();
    this.authService.createUser(data).subscribe(response => {
      console.log('response of create user', response)
      this.presentToast("Cuenta creada con éxito.");
      this.res = response;
      this.show_form = false;

      loading.dismiss();
      console.log(response)


      setTimeout(() => {
        window.location.href = "login";
      }, 1000)
    }, error => {
      console.warn('Error Crear Usuario', error);
      this.presentToast('por favor verifque sus datos, algunos campos contienen información no valida');
      loading.dismiss();
    })

  }
  getTypeIdentificationId() {
    console.log('getTypeDocument')
    this.loading.present();
    this.adminService.getTypeIdentificationId().subscribe((res: any) => {
      this.documents = res;
      console.log(this.documents)
      this.loading.dismiss();
    });
  }

  async presentToast(txt) {
    const toast = await this.toastController.create({
      message: txt,
      duration: 3000,
      position: 'top',
      mode: 'ios',
      color: 'dark'
    });
    toast.present();
  }

  async presentAlert(id) {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: this.text.success,
      subHeader: '',
      message: this.text.account_created,
      buttons: ['OK']
    });

    await alert.present();

    const {role} = await alert.onDidDismiss();

  }


  copyFileToLocalDir(namePath, currentName, newFileName) {
    this.file.copyFile(namePath, currentName, cordova.file.dataDirectory, newFileName).then(success => {

      this.lastImage = newFileName;

    }, error => {
      this.presentToast('Error al almacenar el archivo.');
    });
  }

  pathForImage(img) {
    if (img === null) {
      return '';
    } else {
      return cordova.file.dataDirectory + img;
    }
  }

  removeImage() {
    this.lastImage = null;
  }


  async terms() {
    const modal = await this.modalController.create({
      component: TermsPage,
      animated: true,
      mode: 'ios',
      cssClass: 'my-custom-modal-css',
      backdropDismiss: false,
      swipeToClose: true,
      presentingElement: this.routerOutlet.nativeEl

    });

    modal.onDidDismiss().then(data => {


    })

    return await modal.present();
  }

  validateOnlyNumbers() {
    if (this.document) {
      this.document = String(this.document).replace(/\D/g, '');
      this.document = this.document.substring(0, 12);

    }
    if (this.phone) {
      this.phone = String(this.phone).replace(/\D/g, '');
      this.phone = this.phone.substring(0, 12);
    }
  }

  validateOnlyLetters() {
    if (this.firstName) {
      this.firstName = String(this.firstName).replace(/[^a-zA-ZñÑ]/g, '').substring(0, 20);
    }
    if (this.secondName) {
      this.secondName = String(this.secondName).replace(/[^a-zA-ZñÑ]/g, '').substring(0, 20);
    }
    if (this.firstLastName) {
      this.firstLastName = String(this.firstLastName).replace(/[^a-zA-ZñÑ]/g, '').substring(0, 20);
    }
    if (this.secondSurName) {
      this.secondSurName = String(this.secondSurName).replace(/[^a-zA-ZñÑ]/g, '').substring(0, 20);
    }
  }

  isLowerCaseValid(form): boolean {
    const password = form.password;
    return /[a-z]/.test(password);

  }

  isUpperCaseValid(form): boolean {
    const password = form.password;
    return /[A-Z]/.test(password);
  }

  isNumberValid(form): boolean {
    const password = form.password;
    return /\d/.test(password);
  }

  isSpecialCharacterValid(form): boolean {
    const password = form.password;
    return /[$#*-]/.test(password);
  }

}
